import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as api from '../api/api';
import { pickErrorMessage } from '../lib/apiHelpers';
import { BrandLogo } from '../components/BrandLogo';
import { branding } from '../config/branding';
import { ErrorBanner } from '../components/PageChrome';
import { toastSuccess } from '../lib/toast';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await api.forgotPassword({ email });
      setSent(true);
      toastSuccess('If an account exists, you will receive reset instructions.');
    } catch (err) {
      setError(pickErrorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light p-3">
      <div className="card shadow border-0" style={{ maxWidth: 480, width: '100%' }}>
        <div className="card-body p-4 p-md-5">
          <div className="d-flex align-items-center gap-2 mb-4">
            <BrandLogo />
            <div>
              <h1 className="h5 mb-0">Reset password</h1>
              <p className="text-secondary small mb-0">{branding.productName}</p>
            </div>
          </div>
          {sent ? (
            <p className="text-secondary mb-3">If an account exists, you will receive reset instructions.</p>
          ) : (
            <form onSubmit={handleSubmit}>
              <ErrorBanner message={error} />
              <div className="mb-3">
                <label htmlFor="email" className="form-label">Email</label>
                <input id="email" type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              <button type="submit" className="btn btn-primary w-100" disabled={busy}>{busy ? 'Sending…' : 'Send reset link'}</button>
            </form>
          )}
          <div className="text-center mt-3"><Link to="/login" className="small">Back to sign in</Link></div>
        </div>
      </div>
    </div>
  );
}
